<template>
  <div class="app">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-row>
        <v-col>
          <v-skeleton-loader class="mx-auto" type="button" />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="item in 3" :key="item">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form ref="form" v-show="!showSkeleton">
      <v-row dense>
        <v-col cols="3">
          <v-text-field
            dense
            v-model="form.acao.description"
            :counter="35"
            label="Descrição"
            :error-messages="descriptionErrors"
            @input="$v.form.acao.description.$touch()"
            @blur="$v.form.acao.description.$touch()"
          />
        </v-col>
        <v-col cols="1" class="ml-14">
          <v-switch dense v-model="form.active" label="Ativo" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-row>
            <v-col>
              <v-text-field
                dense
                v-model="form.regexVisualOrigem"
                :error-messages="regexVisualOrigemErrors"
                :counter="20"
                label="Expressão de Origem"
                @input="
                  $v.form.regexVisualOrigem.$touch()
                  form.regexVisualOrigem = $event.trim()
                "
                @blur="$v.form.regexVisualOrigem.$touch()"
              />
            </v-col>
            <v-col>
              <v-text-field
                dense
                v-model="form.regexVisualDestino"
                :error-messages="regexVisualDestinoErrors"
                :counter="20"
                label="Expressão de Destino"
                @input="
                  $v.form.regexVisualDestino.$touch()
                  form.regexVisualDestino = $event.trim()
                "
                @blur="$v.form.regexVisualDestino.$touch()"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select
                dense
                v-model="form.alliasRegexOrigem"
                label="Grupos de Expressões Origem"
                :items="alliasRegexOrigem"
              />
            </v-col>
            <v-col>
              <v-select
                dense
                v-model="form.alliasRegexDestino"
                label="Grupos de Expressões Destino"
                :items="alliasRegexDestino"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col>
          <v-row>
            <v-col>
              <v-select
                dense
                v-model="form.acao.centroDeCusto"
                :error-messages="centroDeCustoErrors"
                :items="centroDeCusto"
                label="Centro de Custo"
                @input="$v.form.acao.centroDeCusto.$touch()"
                @blur="$v.form.acao.centroDeCusto.$touch()"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select dense multiple v-model="form.acao.tag" :items="tags" label="Tags">
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0">{{ item.text }}</span>
                  <v-chip v-if="index === 1" small>
                    <span class="caption"> (+{{ form.acao.tag.length - 1 }}) </span>
                  </v-chip>
                </template>
                <template v-slot:prepend-item>
                  <v-list-item ripple @click="toggleTags">
                    <v-list-item-action>
                      <v-icon :color="form.acao.tag.length > 0 ? 'indigo darken-4' : ''">
                        {{ iconTags }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        Selecionar Todas
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2" />
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'

import { rotasMixin } from '../_mixins/rotasMixins'
import { validateData, validateComputed } from '../_validates/validateOcupado'

export default {
  name: 'TocarSinalDeOcupado',
  mixins: [validationMixin, rotasMixin],
  data: () => ({
    form: {
      description: 'TOCAR SINAL DE OCUPADO',
      regexVisualOrigem: '',
      regexVisualDestino: '',
      alliasRegexOrigem: '',
      alliasRegexDestino: '',
      active: true,
      acao: {
        description: 'TOCAR SINAL DE OCUPADO',
        class: 'Modules\\Agi\\Entities\\acoes\\TocarSinalDeOcupado',
        centroDeCusto: '',
        tag: [],
      },
    },
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...validateComputed,
  },

  async created() {
    await Promise.all([this.listarCentroDeCustos(), this.listarRegex(), this.listarTags()])

    this.getItemsSelectCentroDeCusto()
    this.getItemsSelectRegexOrigemEDestino()
    this.getItemsSelectTags()

    this.makeFormulario()

    this.showSkeleton = false
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
